import React from "react";
import {
  QuestionDropdownModel,
  QuestionFactory,
  Serializer,
  ItemValue,
} from "survey-core";
import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from "survey-react-ui";

const QUESTION_TYPE = "replaceDrugKit";
let isRegistered = false;

/* =========================================================
   QUESTION MODEL - Properly inherit all methods
========================================================= */
class QuestionReplaceDrugKitModel extends QuestionDropdownModel {
  constructor(name) {
    super(name);

    // Initialize choices array using parent method
    this.createNewArray("choices");

    // Set default placeholder
    this.placeholder = "Select replacement drug kit";

    // Default empty choices - users will add them
    // Use parent class method to set choices
    this.setPropertyValue("choices", []);
  }

  getType() {
    return QUESTION_TYPE;
  }

  // Custom placeholder property
  get placeholder() {
    return this.getPropertyValue("placeholder", "Select replacement drug kit");
  }

  set placeholder(val) {
    this.setPropertyValue("placeholder", val);
  }

  // Ensure choices property works properly
  get choices() {
    return this.getPropertyValue("choices");
  }

  set choices(val) {
    this.setPropertyValue("choices", val);
  }
}

/* =========================================================
   REACT RENDERER - Simple dropdown (same as before)
========================================================= */
class SurveyQuestionReplaceDrugKit extends SurveyQuestionElementBase {
  get question() {
    return this.props.question;
  }

  handleChange = (e) => {
    this.question.value = e.target.value || null;
  };

  renderElement() {
    const q = this.question;
    const value = q.value ?? "";

    return (
      <div style={{ width: "100%" }}>
        <select
          value={value}
          onChange={this.handleChange}
          disabled={q.isReadOnly}
          style={{
            width: "100%",
            boxSizing: "border-box",
            padding: "8px 12px",
            borderRadius: "4px",
            border:
              q.errors.length > 0 ? "1px solid #dc3545" : "1px solid #ced4da",
            backgroundColor: q.isReadOnly ? "#e9ecef" : "#fff",
            fontSize: "16px",
            height: "38px",
            cursor: q.isReadOnly ? "not-allowed" : "pointer",
          }}
        >
          <option value="">{q.placeholder}</option>
          {(q.visibleChoices || q.choices || []).map((choice, index) => (
            <option key={choice.value || index} value={choice.value}>
              {choice.text || choice.value}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

/* =========================================================
   REGISTRATION - FIXED
========================================================= */
export function registerReplaceDrugKitQuestion() {
  if (isRegistered) return;
  isRegistered = true;

  // Simple registration - let it inherit everything properly
  Serializer.addClass(
    QUESTION_TYPE,
    [
      {
        name: "placeholder:text",
        category: "general",
        default: "Select replacement drug kit",
        visible: true,
      },
    ],
    () => new QuestionReplaceDrugKitModel(""),
    "dropdown"
  );

  // Fix name property to prevent date detection
  setTimeout(() => {
    const nameProp = Serializer.findProperty(QUESTION_TYPE, "name");
    if (nameProp) {
      nameProp.type = "text";
      nameProp.inputType = "text";
      delete nameProp.dateFormat;
    }
  }, 0);

  // Register with QuestionFactory
  QuestionFactory.Instance.registerQuestion(
    QUESTION_TYPE,
    (name) => new QuestionReplaceDrugKitModel(name)
  );

  // Register React component
  ReactQuestionFactory.Instance.registerQuestion(QUESTION_TYPE, (props) =>
    React.createElement(SurveyQuestionReplaceDrugKit, props)
  );
}

// Auto-register
registerReplaceDrugKitQuestion();

export default QuestionReplaceDrugKitModel;
